// Launch mode (roadmap 43): the "I'm in" buttons. The server counts one per browser id; this page only asks and shows the answer.
import { IM_IN_DEFAULT, IM_IN_COUNTED, IM_IN_COUNTED_NOTE, IM_IN_ERROR, imInCountLine } from '/game/teaser.js';

const browserId = () => {
  try {
    let id = localStorage.getItem('door.browserId');
    if (!id) { id = crypto.randomUUID(); localStorage.setItem('door.browserId', id); }
    return id;
  } catch { return null; }
};
const remembered = () => { try { return localStorage.getItem('door.imIn') === '1'; } catch { return false; } };
const remember = () => { try { localStorage.setItem('door.imIn', '1'); } catch { /* private mode */ } };

const show = (btn, counted) => {
  btn.querySelector('.t').textContent = counted ? IM_IN_COUNTED : IM_IN_DEFAULT;
  btn.disabled = counted;
  btn.setAttribute('aria-pressed', String(counted));
  const note = btn.parentElement.querySelector('.im-in-note');
  if (note) { note.textContent = counted ? IM_IN_COUNTED_NOTE : ''; note.hidden = !counted; }
};
const fail = btn => {
  const note = btn.parentElement.querySelector('.im-in-note');
  if (note) { note.textContent = IM_IN_ERROR; note.hidden = false; }
};

const buttons = [...document.querySelectorAll('[data-im-in]')];
const setAll = counted => buttons.forEach(b => show(b, counted));
const setCount = n => {
  if (typeof n !== 'number') return;
  for (const el of document.querySelectorAll('.im-in-count')) { el.textContent = imInCountLine(n); el.hidden = !el.textContent; }
};
if (buttons.length) {
  const id = browserId();
  if (remembered()) setAll(true);
  if (id) fetch(`/im-in?browserId=${encodeURIComponent(id)}`).then(r => r.json()).then(r => { setCount(r.count); if (r.counted) { remember(); setAll(true); } }).catch(() => {});
  for (const b of buttons) b.addEventListener('click', async () => {
    if (b.disabled || !id) return;
    try {
      const res = await fetch('/im-in', { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ browserId: id }) });
      if (!res.ok) throw new Error('not saved');
      setCount((await res.json().catch(() => ({}))).count);
      remember(); setAll(true);
    } catch { fail(b); }
  });
}
